import { useSelector } from 'react-redux';
import { isMobileBrowser } from '../base/environment/utils';
import { isVpaasMeeting } from '../jaas/functions';
import EmbedMeetingButton from './components/EmbedMeetingButton';
const embed = {
    key: 'embedmeeting',
    Content: EmbedMeetingButton,
    group: 4
};
/**
 * A hook that returns the embed button if it is enabled and undefined otherwise.
 *
 *  当前需求：web 端「应用」菜单不再展示「嵌入会议」入口，因此该 hook 始终返回 undefined。
 *  如未来需恢复，把下方 `return undefined;` 替换为原始判断即可。
 *
 *  @returns {Object | undefined}
 */
export function useEmbedButton() {
    // 业务调整：web 端下线「嵌入会议」菜单项，统一返回 undefined 让 toolbox 过滤掉。
    // 保留对 useSelector 的调用以维持 React hooks 顺序稳定；保留 isMobileBrowser / isVpaasMeeting 引入以备回滚。
    const _isVpaasMeeting = useSelector(isVpaasMeeting);
    void isMobileBrowser;
    void _isVpaasMeeting;
    void embed;
    return undefined;
}
